var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo-wrapper d-none d-xl-block",class:{ condensed : _vm.isCondensed },attrs:{"href":_vm.target}},[_c('div',{staticClass:"logo"},[_c('span',[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.primary}})]),_vm._v(" "),_c('span',[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.secondary}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }